import React, { MutableRefObject, useEffect, useRef } from 'react';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import Input from '../../components/forms/Input';
import SectionTitle from '../../components/SectionTitle';
import FormFactory from '@/components/FormFactory';
import QuotesService from '@/common/API/QuotesService';
import RichEditor from '@/components/forms/RichEditor';
import Select from '@/components/forms/Select';
import { Button } from '@/components/ui/button';
import { Field } from 'formik';
import { text } from 'stream/consumers';
import { UserService } from '@/common/API/UserService';
import { UserType } from '@/common/types/UserType';

const ProfileUpdateScreen = () => {
  const formRef: MutableRefObject<any> = useRef();

  useEffect(() => {
    UserService.getPorfile().then((res: any) => {
      const { name, email } = res.data;
      formRef.current.setValues({
        name,
        email,
      });
    });
  }, []);

  return (
    <Screen
      screenOptions={{
        header: {
          title: 'Personal information',
          backBtnLabel: 'Settings',
          backBtnUrl: './../',
          titleClassName: 'text-white',
        },
      }}
      screenContainerClassName='bg-black'
      className='grid grid-rows-5 px-4'
    >
      <FormFactory formRef={formRef} className='row-span-4 h-full' initialValues={{ name: '', email: '' }}>
        <Field name='name' placeholder='Name & surname' component={Input} />
        <Field name='email' placeholder='Email' component={Input} />
      </FormFactory>
      <div className='row-span-1 w-full flex items-end'>
        <Button
          onClick={() => {
            console.log(formRef.current.values);
            UserService.updateProfile(formRef.current.values);
          }}
          className='w-full'
        >
          Update profile
        </Button>
      </div>
      {/* <span className='dark:text-neutral-400 uppercase text-xs mb-2 block'>Change password</span>
        <section className='bg-white dark:bg-neutral-800 rounded-lg'>
          <Input placeholder='Old password' />
          <Input placeholder='New password' />
          <Input placeholder='Confirm password' />
        </section> */}
    </Screen>
  );
};

export default ProfileUpdateScreen;
